import type { RootState } from 'src/store';
import { connect } from 'react-redux';

import { setFinishes } from '../../documents/slice';
import { FinishData } from 'src/services/materialClient';
import FinishSelector from 'src/components/finish/finishSelector';
import getFinishFromLayer from 'src/selectors/layers/getFinish';

const mapStateToProps = (state: RootState, ownProps: { id: string }) => {
    const { id } = ownProps;
    const finishes = getFinishFromLayer(state, id);
    return { id, finishes };
};
const finishContainer = connect(mapStateToProps, {
    onSelect: (id: string, finishes: FinishData[]) => setFinishes({ id, finishes }),
})(FinishSelector);

export default finishContainer;
